import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPicturePolaroidLandscape = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "picture-polaroid-landscape" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: .75,
			y: .75,
			width: 15,
			height: 16.5,
			rx: .75,
			ry: .75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 15.75,
			y1: 12.75,
			x2: .75,
			y2: 12.75
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M18.755,6.231l3.982,1.327a.75.75,0,0,1,.474.949l-4.743,14.23a.75.75,0,0,1-.949.474L6.755,19.623"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M5.25,12.75,9.4,6.818A1.5,1.5,0,0,1,11.76,6.69l3.99,4.56"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 5.063,
			cy: 5.063,
			r: 1.688
		})
	]
});
export default SvgPicturePolaroidLandscape;
